import React from "react";

const points = [
  "Experienced & qualified homeopathic doctor",
  "Personalized treatment plans",
  "Safe for children & elderly",
  "Modern clinic with traditional values",
  "Friendly and supportive environment",
];

export default function Mission() {
  return (
    <section id="mission">
      <div className="mission-section">

        {/* TITLE */}
        <div className="section-title">
          <span></span>
          <h2>OUR MISSION</h2>
          <span></span>
        </div>

        <div className="mission-container">

          {/* LEFT - MISSION */}
          <div className="mission-box">
            <div className="mission-icon">👩‍⚕️</div>
            <h3>Our Mission</h3>
            <p>
              Our mission is to provide affordable, compassionate, and effective
              homeopathic treatment to families in our community. We aim to
              promote wellness through natural healing and preventive care.
            </p>
          </div>

          {/* RIGHT - WHY CHOOSE US */}
          <div className="choose-box">
            <h3>💚 Why Choose Us?</h3>

            <div className="choose-list">
              {points.map((item, index) => (
                <div className="choose-item" key={index}>
                  <span>✔</span>
                  <p>{item}</p>
                </div>
              ))}
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}